import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Index from "../Index";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Box } from "@mui/material";

const MenuItemList = ({ array, type, closeSidebar }) => {
  const checkActive = (link) => {
    if (!link) return false;
    const currentPath = window.location.pathname;
    if (currentPath.toLowerCase() === link.toLowerCase() || currentPath.toLowerCase().startsWith(link.toLowerCase() + "/")) {
      return true;
    }

    const getSuperCleanName = (url) => {
      const parts = url.split("/").filter(Boolean);
      if (parts.length === 0) return "";
      let last = parts[parts.length - 1];
      if (last.match(/^[a-fA-F0-9-]+$/) || !isNaN(last)) {
        last = parts[parts.length - 2] || "";
      }
      
      last = last.toLowerCase();
      
      // Normalize typos/inconsistencies
      const replacements = {
        "credite": "credit",
        "purches": "purchase",
        "\\bnot\\b": "note", // Match exact word "not" to avoid matching things like "nothing"
        "-not-": "-note-",
        "-not": "-note"
      };
      for (const [typo, correct] of Object.entries(replacements)) {
        last = last.replace(new RegExp(typo, 'g'), correct);
      }
      
      const prefixes = ["generate-", "edit-", "view-", "preview-", "create-", "add-"];
      for (const prefix of prefixes) {
        if (last.startsWith(prefix)) {
          last = last.substring(prefix.length);
        }
      }
      
      const suffixes = ["-list", "-master", "-entry", "-voucher", "-report"];
      for (const suffix of suffixes) {
        if (last.endsWith(suffix)) {
          last = last.substring(0, last.length - suffix.length);
        }
      }
      
      for (const suffix of suffixes) {
        if (last.endsWith(suffix)) {
          last = last.substring(0, last.length - suffix.length);
        }
      }
      for (const prefix of prefixes) {
        if (last.startsWith(prefix)) {
          last = last.substring(prefix.length);
        }
      }
      
      return last;
    };

    const linkClean = getSuperCleanName(link);
    const pathClean = getSuperCleanName(currentPath);

    if (linkClean && pathClean) {
      const singular = (word) => (word.endsWith("s") && !word.endsWith("ss") ? word.substring(0, word.length - 1) : word);
      const linkSingular = singular(linkClean);
      const pathSingular = singular(pathClean);

      if (linkSingular === pathSingular) {
        const linkHasReport = link.toLowerCase().includes("report");
        const pathHasReport = currentPath.toLowerCase().includes("report");
        if (linkHasReport !== pathHasReport) {
          return false;
        }
        return true;
      }
      if (linkClean === "sales-order" && (pathClean === "salesorder" || pathClean === "preview-sales-order" || pathClean === "edit-order")) {
        const linkHasReport = link.toLowerCase().includes("report");
        const pathHasReport = currentPath.toLowerCase().includes("report");
        if (linkHasReport === pathHasReport) {
          return true;
        }
      }
      
      const commonPrefixes = ["sales", "purchase", "purches", "product", "prouduct", "account", "debit", "gst", "interest", "bank", "stock", "credit", "gstr", "tax", "cashbank", "balance", "gst2b"];
      const getFirstWord = (name) => name.split("-")[0];
      const linkFirst = getFirstWord(linkSingular);
      const pathFirst = getFirstWord(pathSingular);
      if (linkFirst && pathFirst && linkFirst === pathFirst && !commonPrefixes.includes(linkFirst)) {
        return true;
      }
    }
    return false;
  };

  // Walks the menu tree and returns the [top, level1, level2] name-path
  // that contains the link matching the current URL, so that on page load
  // the branch leading to the active page is expanded (and nothing else is).
  const findInitialExpandedPath = () => {
    for (const item of array || []) {
      if (!(item.type === type && item?.permission) || !item.child) continue;
      for (const child1 of item.child) {
        if (!child1.permission) continue;
        if (!child1.child) {
          if (checkActive(child1.link)) return [item.name];
          continue;
        }
        for (const child2 of child1.child) {
          if (!child2?.permission) continue;
          if (!child2.child) {
            if (checkActive(child2.link)) return [item.name, child1.name];
            continue;
          }
          for (const child3 of child2.child) {
            if (child3?.permission && checkActive(child3.link)) {
              return [item.name, child1.name, child2.name];
            }
          }
        }
      }
    }
    return [];
  };

  const [expandedPath, setExpandedPath] = useState(findInitialExpandedPath);

  const handleTopChange = (key) => (event, isExpanded) => {
    setExpandedPath(isExpanded ? [key] : []);
  };
  const handleLevel1Change = (topKey, key) => (event, isExpanded) => {
    setExpandedPath(isExpanded ? [topKey, key] : [topKey]);
  };
  const handleLevel2Change = (topKey, level1Key, key) => (event, isExpanded) => {
    setExpandedPath(isExpanded ? [topKey, level1Key, key] : [topKey, level1Key]);
  };

  return (
    <>
      {array?.map((e, i) => {
        return (
          <>
            {(e.type === type && e?.permission) && (
              <>
                <li className="li-sidebar-list">
                  <Accordion
                    className="cus-accordion"
                    key={e.name || i}
                    expanded={expandedPath[0] === e.name}
                    onChange={handleTopChange(e.name)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Index.Box className="sidebar-btn-list">
                        <img src={Index.Svg[e.icon]} className="sidebar-icons"></img>
                        {e.name}
                      </Index.Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      {e.child &&
                        e.child.map((e1) => {
                          return (
                            <React.Fragment key={e1.name}>
                              {!e1.child ? (
                                e1.permission && (
                                  <NavLink
                                    className={({ isActive }) => (isActive || checkActive(e1.link) ? "active" : "")}
                                    to={e1.link}
                                    onClick={closeSidebar}
                                  >
                                    <Index.Box className="sidebar-btn-list">
                                      <img src={Index.Svg[e1.icon]} className="sidebar-icons"></img>{e1.name}</Index.Box></NavLink>)
                              ) : (
                                e1.permission && (<Accordion
                                  className="sub-accord nested-accordion"
                                  expanded={expandedPath[0] === e.name && expandedPath[1] === e1.name}
                                  onChange={handleLevel1Change(e.name, e1.name)}
                                >
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                  >
                                    <Index.Box className="sidebar-btn-list">
                                      <img src={Index.Svg[e1.icon]} className="sidebar-icons"></img>
                                      {e1.name}
                                    </Index.Box>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    {e1.child &&
                                      e1.child.map((e2) => {
                                        return (
                                          <React.Fragment key={e2.name}>
                                            {!e2.child ? (
                                              e2?.permission && (
                                                <NavLink
                                                  className={({ isActive }) => (isActive || checkActive(e2.link) ? "active" : "")}
                                                  to={e2.link}
                                                  onClick={closeSidebar}
                                                >
                                                  <Index.Box className="sidebar-btn-list">
                                                    <img src={Index.Svg[e2.icon]} className="sidebar-icons"></img>
                                                    {e2.name}</Index.Box></NavLink>)
                                            ) : (
                                              e2?.permission && (<Accordion
                                                className="sub-accord nested-accordion"
                                                expanded={expandedPath[0] === e.name && expandedPath[1] === e1.name && expandedPath[2] === e2.name}
                                                onChange={handleLevel2Change(e.name, e1.name, e2.name)}
                                              >
                                                <AccordionSummary
                                                  expandIcon={<ExpandMoreIcon />}
                                                  aria-controls="panel1a-content"
                                                  id="panel1a-header"
                                                >
                                                  <Index.Box className="sidebar-btn-list">
                                                    <img src={Index.Svg[e2.icon]} className="sidebar-icons"></img>
                                                    {e2.name}
                                                  </Index.Box>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                  {e2.child &&
                                                    e2.child.map((e3) => {
                                                      return (
                                                        e3?.permission && (
                                                          <NavLink
                                                            key={e3.name}
                                                            className={({ isActive }) => (isActive || checkActive(e3.link) ? "active" : "")}
                                                            to={e3.link}
                                                            onClick={closeSidebar}
                                                          >
                                                            <Index.Box className="sidebar-btn-list">
                                                              <img src={Index.Svg[e3.icon]} className="sidebar-icons"></img>{e3.name}
                                                            </Index.Box></NavLink>)
                                                      );
                                                    })}
                                                </AccordionDetails>
                                              </Accordion>)
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                  </AccordionDetails>
                                </Accordion>)
                              )}
                            </React.Fragment>
                          );
                        })}
                    </AccordionDetails>
                  </Accordion>
                </li>
              </>
            )}
          </>
        );
      })}
    </>
  );
};
export default MenuItemList;
